import script from "./ProjectListModify.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectListModify.vue?vue&type=script&setup=true&lang=js"

import "./ProjectListModify.vue?vue&type=style&index=0&id=fdda6b50&lang=css"
import "./ProjectListModify.vue?vue&type=style&index=1&id=fdda6b50&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdda6b50"]])

export default __exports__